import { useEffect, useState } from 'react';

import { Facility, FacilityLicense, UserRole } from 'models';
import { ArtificialFacilityConfiguration, FacilityNurseStaffingAccordionItem } from 'pages/Settings/Tabs';
import { checkLicenseBits, intersects, userIs } from 'utils';
import { useAppSelector, useGetSystemsQuery, useSystem } from 'store';
import { Accordion, WorkingIndicator } from 'components';
import { Routes as NavigationRoutes } from 'models/navigation';

export function NurseStaffingSettings() {
	// automatically gets current "selected" system information
	const { data, isFetching } = useSystem();
	const isAdministrator = userIs([UserRole.admin, UserRole.healthsystem_admin], data?.user);
	const [rebuildingArtificial, setRebuildingArtificial] = useState<boolean | number>(false);
	const { selectedSystem } = useAppSelector((state) => state.userState);
	const { data: userData } = useGetSystemsQuery({
		healthsystem_id: selectedSystem,
	});
	// This is required to unmount the accordion when fetching new artificial facilities
	useEffect(() => {
		if (!isFetching) {
			setRebuildingArtificial(false);
		}
	}, [isFetching]);

	const earlyAccessValidation = intersects(userData?.user.page_list ?? [], [NavigationRoutes.NURSE_STAFFING]);

	const anesthesiaFacilitiesCount =
		data?.facilities?.filter((fac) => checkLicenseBits(fac.license, FacilityLicense.nurse_staffing)).length ||
		earlyAccessValidation
			? 1
			: 0;

	return (
		<div>
			{isFetching && (
				<div className='w-full flex justify-center my-4'>
					<div>
						<WorkingIndicator />
					</div>
				</div>
			)}
			{!isFetching &&
				data?.facilities
					?.filter((fac) => checkLicenseBits(fac.license, FacilityLicense.nurse_staffing) || earlyAccessValidation)
					.map((facility: Facility, index: number) => {
						if (rebuildingArtificial !== false) {
							if (index !== rebuildingArtificial) {
								return (
									<FacilityNurseStaffingAccordionItem
										key={index}
										facility={facility}
										readonly={!isAdministrator}
										fetching={isFetching}
										rebuildingArtificial={() => setRebuildingArtificial(index)}
									/>
								);
							} else {
								return (
									<Accordion type='multiple' itemStyle='yellow' className='mb-2'>
										<Accordion.Item value={`[Rebuilding] ${facility.name}`}></Accordion.Item>
									</Accordion>
								);
							}
						} else {
							return (
								<FacilityNurseStaffingAccordionItem
									key={index}
									facility={facility}
									readonly={!isAdministrator}
									fetching={isFetching}
									rebuildingArtificial={() => setRebuildingArtificial(index)}
								/>
							);
						}
					})}

			{!isFetching && anesthesiaFacilitiesCount > 1 && (
				<ArtificialFacilityConfiguration
					facilities={data?.facilities?.filter((fac) => checkLicenseBits(fac.license, FacilityLicense.nurse_staffing)) ?? []}
				></ArtificialFacilityConfiguration>
			)}
		</div>
	);
}

export default NurseStaffingSettings;
